import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import App from '@/App'
import '@/entrypoints/application.css'

const container = document.getElementById('root')

if (container) {
  const app = (
    <StrictMode>
      <App />
    </StrictMode>
  )

  // The server pre-rendered this page (see Ssr::Renderer) -- hydrate it in
  // place. Without server markup (SSR down, or a cache miss path), render
  // from scratch exactly as before.
  if (container.hasChildNodes()) {
    hydrateRoot(container, app)
  } else {
    createRoot(container).render(app)
  }
}
